'use client'
import Image from 'next/image'
import Link from 'next/link'
import { IconArrowR } from '@/icons'
import Reveal from '@/components/Reveal'
import { PRODUCT_GROUPS } from '@/lib/products'

export default function Products() {
  return (
    <section id="products" className="sec-pad">
      <div className="container">
        <Reveal><div className="sec-head">
          <h2>Продукция</h2>
        </div></Reveal>
        <div className="products-grid">
          {PRODUCT_GROUPS.map((p, i) => (
            <Reveal key={p.id} delay={i * 90}>
            <Link className="product-card" href={p.href}>
              <div className="pc-img">
                <Image src={p.image} alt={p.imageAlt} fill sizes="(max-width: 480px) 100vw, (max-width: 860px) 50vw, 25vw" style={{ objectFit: 'cover' }} />
              </div>
              <div className="pc-body">
                <h3>{p.shortTitle}</h3>
                <div className="pc-desc">{p.desc}</div>
                <span className="pc-cta">Смотреть товары <IconArrowR width="14" height="14" /></span>
              </div>
            </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
